import { render } from "./FeatInfoArticle.vue?vue&type=template&id=15dcd6c2&scoped=true"
import script from "./FeatInfoArticle.vue?vue&type=script&lang=js"
export * from "./FeatInfoArticle.vue?vue&type=script&lang=js"

import "./FeatInfoArticle.vue?vue&type=style&index=0&id=15dcd6c2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15dcd6c2"]])

export default __exports__